import { getTimeUntilStart } from "@/utils/challengeHelpers";

interface ChallengeCardProps {
  title: string;
  imageUrl: string;
  currentDay: number;
  totalDays: number;
  progressPercentage: number;
  status: "upcoming" | "active" | "completed";
  isUserParticipant: boolean;
  startDate: string;
  participantCount: number;
  onClick?: () => void;
}

export function ChallengeCard({
  title,
  imageUrl,
  currentDay,
  totalDays,
  progressPercentage,
  status,
  isUserParticipant,
  startDate,
  participantCount,
  onClick,
}: ChallengeCardProps) {
  const isUpcoming = status === "upcoming";
  const showProgress = isUserParticipant && status === "active";

  return (
    <div
      className="flex h-full w-[70vw] max-w-xs shrink-0 flex-col gap-3 rounded-xl cursor-pointer transition-transform hover:scale-105"
      onClick={onClick}
    >
      {/* Challenge Image with Badge */}
      <div className="relative">
        <div
          className="w-full aspect-video bg-cover bg-center bg-no-repeat rounded-4xl"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />

        {/* Participant Count Badge - Platform active challenges */}
        {!isUserParticipant && !isUpcoming && (
          <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-black/60 backdrop-blur-sm flex items-center gap-1">
            <span className="material-symbols-outlined text-sm text-white">group</span>
            <span className="text-xs font-medium text-white">
              {participantCount}
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div>
        <p className="text-lg font-bold leading-normal text-slate-900 dark:text-white">
          {title}
        </p>

        {/* Progress Bar - Only for user's active challenges */}
        {showProgress && (
          <>
            <div className="w-full bg-slate-200 dark:bg-white/10 rounded-full h-2 mt-2">
              <div
                className="bg-primary h-2 rounded-full glow-primary"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <p className="text-sm font-normal leading-normal mt-1.5 text-slate-600 dark:text-slate-400">
              Day {currentDay} of {totalDays}
            </p>
          </>
        )}

        {/* Duration info for upcoming/non-participant */}
        {!showProgress && (
          <p className="text-sm font-normal leading-normal mt-1.5 text-slate-600 dark:text-slate-400">
            {isUpcoming ? getTimeUntilStart(startDate) : `${totalDays} day challenge`}
          </p>
        )}
      </div>
    </div>
  );
}
